const BarChart = props => {
    const { data } = props;
    const { note, mobileNote, demos, question, response } = data[0];

    const getStyle = index => {
        if (0 === index % 2 || 0 === index) {
            return '33px';
        }
        return '7px';
    };

    const calculateWidth = percentages => {
        const { White, Black } = percentages;

        const whitePercent = White === undefined ? 0 : White + 1.5;
        const blackPercent = Black === undefined ? 0 : Black + 1.5;
        const percentage = whitePercent - blackPercent;

        const width = Math.abs(percentage);
        return `${width - 2.5}%`;
    };

    return (
        <div data-name="race-relations" className="table-container">
            <div className="axis-anchors">
                <div className="bumper" />
                <span className="hundred">100%</span>
            </div>
            {demos.map((demo, i) => {
                const { group, percentages } = demo;
                const { White, Black, Gap, Significant } = percentages;
                return (
                    <div
                        className="bar-container All"
                        style={{ marginBottom: getStyle(i) }}
                    >
                        <div className="demo-group">{group}</div>
                        <div
                            className="shaded-background"
                            id={`${group}`}
                            style={{
                                backgroundColor: 'transparent',
                            }}
                        >
                            {White ? (
                                <div
                                    className={`circle white ${
                                        White === Black ? 'same-value' : ''
                                    }`}
                                    data-percentage={`${White}%`}
                                    style={{
                                        marginLeft: `${White - 2}%`,
                                    }}
                                >
                                    {White}
                                </div>
                            ) : (
                                ''
                            )}

                            {Black && White && White !== Black ? (
                                <div
                                    className="difference-bar"
                                    data-percentage="16"
                                    data-significant="true"
                                    style={{
                                        marginLeft: `${
                                            White > Black
                                                ? Black + 1.5
                                                : White + 1.5
                                        }%`,
                                        width: calculateWidth(percentages),
                                        marginRight: `${
                                            White > Black
                                                ? White + 1.5
                                                : Black + 1.5
                                        }%`,
                                        color: 'rgb(0, 0, 0)',
                                        backgroundColor: ' rgb(204, 204, 204)',
                                    }}
                                >
                                    <span style={{ display: 'block' }}>
                                        {Math.abs(White - Black)}
                                    </span>
                                </div>
                            ) : (
                                ''
                            )}
                            {Black && White !== Black ? (
                                <div
                                    className="circle black"
                                    data-percentage={`${Black}%`}
                                    style={{
                                        marginLeft: `${Black - 2}%`,
                                    }}
                                >
                                    {Black}
                                </div>
                            ) : (
                                ''
                            )}

                            {0 === i ? (
                                <>
                                    <div
                                        id="black-label"
                                        className="legend"
                                        style={{
                                            marginLeft: `${
                                                Black > White
                                                    ? Black + 3
                                                    : Black - 10
                                            }%`,
                                        }}
                                    />
                                    <div
                                        id="white-label"
                                        className="legend"
                                        style={{
                                            marginLeft: `${
                                                White > Black
                                                    ? White + 3
                                                    : White - 10
                                            }%`,
                                        }}
                                    />
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                );
            })}

            <div className="source" id="desktop-source">
                {note.split('For exact question')[0]}
                For exact question wording, refer to the{' '}
                <a href={note.split('href="')[1].split('">')[0]}>
                    topline questionnaire.
                </a>
            </div>
            <div className="source" id="mobile-source">
                {mobileNote.split('For exact question')[0]}
                For exact question wording, refer to the{' '}
                <a href={mobileNote.split('href="')[1].split('">')[0]}>
                    topline questionnaire.
                </a>
            </div>
        </div>
    );
};

export default BarChart;
